import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';

import DivLeftAlign from "../../../../../shared/components/Styled/DivLeftAlign.jsx";
import H6TitleLeftAlign from "../../../../../shared/components/Styled/H6TitleLeftAlign.jsx";
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx";
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx";
import ParagraphRightAlign from "../../../../../shared/components/Styled/ParagraphRightAlign.jsx";
import FreelanceAgent from "../../../../components/Agent/FreelanceAgent.jsx";
import H5TitleLeftAlign from "../../../../../shared/components/Styled/H5TitleLeftAlign.jsx";

export default class Introduction extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
  };

  render() {
    const { freelance } = this.props

    return (
      <Fragment>
        <H5TitleLeftAlign title="Finalisation de votre profil"/>
        <DivLeftAlign>
            Plus qu'une étape avant de valider votre profil ! Pour rappel, <strong>toutes les informations que nous allons vous demander sont primordiales
            pour valider votre profil et nous permettre d'avoir</strong> :
          <ul>
            <li>Un <strong>référencement efficace</strong> pour le moteur de recherche, afin que vous remontiez en première page pour les recherches pertinentes</li>
            <li>Une <strong>lecture rapide</strong> des différents profils</li>
            <li>Une <strong>valorisation</strong> de l'ensemble des profils</li>
          </ul> 
        </DivLeftAlign>

        <H6TitleLeftAlign title="La complétude de ces informations se divise en 3 étapes"/>
        <ParagraphLeftAlign text={"1) Une présentation synthétique de votre profil"}/>
        <ParagraphLeftAlign text={"2) Renseigner vos diplômes, certifications, langues etc."}/>
        <ParagraphLeftAlign text={"3) Une description de vos expériences et/ou missions"}/>

        <ParagraphLeftAlign className={'line-height-sm mt-4'}>
          <strong>Attention : je vous conseille fortement de réaliser ces étapes depuis un ordinateur et non depuis votre téléphone !</strong>
        </ParagraphLeftAlign>

        {(freelance.agent && freelance.agent.id) &&
          <div className="mt-4">
            <FreelanceAgent agentId={freelance.agent_id ? freelance.agent_id: freelance.agent.id}/>
          </div>
        }

        <ParagraphRightAlign className={'mt-4'}>
          <PrimaryButton onClick={this.props.nextPage}>
            J'ai compris
          </PrimaryButton>
        </ParagraphRightAlign>
      </Fragment>
    )
  }
}
